import './Attention.sass'
import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from "./Buttons/CloseButton/CloseButton";

Attention.propTypes = {
    closeHandler: PropTypes.func.isRequired,
    attentionText: PropTypes.string.isRequired
};

function Attention(props) {


    return (
        <div ref={props.reff} className={'attention '}>
            <CloseButton onClick={props.closeHandler}/>
            {props.attentionText}
        </div>
    );
}

export default Attention;